/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This project doesn't exist or you don't have access to it. The link may be broken or the project may have been removed." |
*
* @param {Project_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_not_found_description = /** @type {((inputs?: Project_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Projekt existiert nicht oder du hast keinen Zugriff darauf. Der Link ist möglicherweise ungültig oder das Projekt wurde entfernt.")
	return /** @type {LocalizedString} */ ("This project doesn't exist or you don't have access to it. The link may be broken or the project may have been removed.")
});